import {DescriptionText, FlexContainer, H2Text} from "../../../../../design";
import React from "react";
import SmallScreenHeader from "../../../../../components/smallscreen/header";

type Props = {
  account: Object,
  subscription: Object,
  cancelUrlLink: String,
}

const Header = (props:Props) => {
  const {account, subscription, cancelUrlLink } = props;
  
  const customContainerProps = {
    // borderWidth: '5px !important',
    // borderColor: '#000 !important',
    // borderStyle: 'solid !important',
    borderRadius: '10px !important',
    width: '100%',
    padding: '5% !important',
    backgroundColor: '#fff',
  };

  const customFlexContainerProps = {
    width: '100%',
  }

  const customPrimaryHeadingProps = {
    fontWeight: 'bold',
    marginTop: '5px',
    marginBottom: '5px',
    fontSize: '20px',
  };

  const customSecondaryHeadingProps = {
    fontWeight: 'bold',
    textTransform: 'none',
    marginRight: '10px',
  }

  const customDescriptionProps = {
    fontSize: '18px',
    whiteSpace: 'wrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  };
  
  return (
    <SmallScreenHeader cancelUrlLink={cancelUrlLink}>
      <FlexContainer {...customContainerProps}>
        <FlexContainer {...customFlexContainerProps}>
          <H2Text {...customSecondaryHeadingProps}>
            {account && account.name}
          </H2Text>
          <DescriptionText {...customDescriptionProps}>
            {subscription && subscription.description}
          </DescriptionText>
        </FlexContainer>
      </FlexContainer>
    </SmallScreenHeader>
  )
};

export default Header;
